var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Bell = require('./bell.jsx');

var DashboardSideMyGi = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className="dashboard-side">
                {this.props.activeItems.length === 1 &&
                    <Bell
                        item={this.props.activeItems[0]}
                        itemScores={this.props.id2ItemScoresData[this.props.activeItems[0].id].scores}
                    />
                }
            </div>
        )
    }
});

module.exports = DashboardSideMyGi;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardSideMyGi.jsx